APP.SSO = (/** @lends APP.SSO */function () {
	'use strict';
	var autoLogin,
		attemptAuthentication,
		logoutFromSSO,
		setFailedCookie,
		removeFailedCookie;

	autoLogin = function() {
		if (!window.getCookie(window.openamParams.failedCookieName) && window.initialParams.loginStatus !== 'loggedin') {
			attemptAuthentication({
				api_endpoint: window.openamParams.userEndpoint,
				login_url: window.openamParams.loginUrl
			});
		}
	};

	attemptAuthentication = function(data) {
		$.ajax({
			type: 'POST',
			url: data.api_endpoint,
			contentType: 'application/json; charset=UTF-8',
			xhrFields: {
				withCredentials: true
			},
			success: function (response, textStatus, jqXHR) {
				if (jqXHR.status === 200) {
					removeFailedCookie();
					window.location.href = data.login_url;
				} else {
					setFailedCookie();
				}
			},
			error: function() {
				setFailedCookie();
			}
		});
	};

	setFailedCookie = function() {
		var expirationDate = new Date();

		expirationDate.setTime(expirationDate.getTime() + 30 * 60 * 1000);
		document.cookie = window.openamParams.failedCookieName + '=true; path=/; domain=' + window.openamParams.cookieDomain;
	};

	removeFailedCookie = function() {
		var expirationDate = new Date();

		expirationDate.setTime(0);
		document.cookie = window.openamParams.failedCookieName + '=; path=/; domain=' + window.openamParams.cookieDomain;
	};

	logoutFromSSO = function() {
		$.ajax({
			type: 'POST',
			url: window.openamParams.logoutEndpoint,
			headers: {
				iplanetDirectoryPro: window.getCookie(window.openamParams.successCookieName)
			},
			success: function(data, textStatus, xhr) {
				if (xhr.status === 200) {
					removeFailedCookie();
				}
			},
			error: function(xhr, textStatus) {
				console.error('Hiba történt a kérés során:', textStatus);
			},
			complete: function() {
				window.location.href = window.openamParams.logoutUrl;
			}
		});
	};

	return {
		init: function() {
			$(document).ready(function() {
				autoLogin();

				$('[data-ref="sso-logout"]').click(function(e) {
					e.preventDefault();
					logoutFromSSO();
				});

			});
		}
	};
}());
